
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "react-localize-redux";
import autoBind from 'auto-bind'

/** Material-UI imports section */
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';

/** Import section component */
import Toaster from '../../common/Toaster';
import DialogActions from '@material-ui/core/DialogActions';
import PreparedBySelector from '../../common/PreparedBySelector';

/**
 * Component Form Raw material non conformity
 */
class FormView extends Component {

    constructor(props){
        super(props);
        autoBind(this);
        this.state = {
            showToaster: false,
            toasterMessage: null,
            toasterVariant: "",
            preparedBySelected: null,
            comments: "",
        }
    }

     /**
     * On seleted prepare by
     */
    onPrepareBySelected(prepareBy){
        this.setState({preparedBySelected: prepareBy});
    }

     /**
     * Update the property of the devolution
     *
     * @param {*} user
     * @param {*} value
     * @memberof View
     */
    updateProperty(comments) {
        this.setState({
            comments: comments
        })
    }

    /**
     * Can be add item in raw material
     */
    canBeSaved(){
        if(this.state.preparedBySelected === null)
            return false;
        else
            return true;
    }

    /**
     * Metho to can be created devolution
     */
    canBeCreateNonconformity(){
        if(this.props.canBeCreate){
            this.props.canBeCreate(this.state.preparedBySelected, this.state.comments)
        }   
    }

    /**
     * Render show 
     */
    render(){
        const { classes } = this.props;
        let qualityFailure = this.props.qualityFailure;
        let notification = qualityFailure.documents.find(document => (document.document_type) === "FAILUREREPORTQUALITYNOTIFICATION")
        return(
            <div className={classes.container} noValidate autoComplete="off">
                <Grid item xs={6}>

                    <div className={classes.textField} ><br/>
                        <Typography variant="body2" gutterBottom><strong><Translate id="common.partNumber"/></strong>
                        {": "}{qualityFailure.full_part_description}
                        </Typography>
                    </div>

                    <div className={classes.textField} ><br/>
                        <Typography variant="body2" gutterBottom><strong><Translate id="common.supplier"/></strong>
                        {": "}{qualityFailure.full_supplier}
                        </Typography>
                    </div>

                    <div className={classes.textField} ><br/>
                        <Typography variant="body2" gutterBottom><strong><Translate id="rawmaterialnonconformity.developmentEnginner"/></strong>
                        {": "}{notification && notification.development_engineer_name}
                        </Typography>
                    </div>

                    <div className={classes.textField} ><br/>
                        <Typography variant="body2" gutterBottom><strong><Translate id="rawmaterialnonconformity.planningEnginner"/></strong>
                        {": "}{notification && notification.planning_engineer_name}
                        </Typography>
                    </div>

                </Grid>

                <Grid item xs={6}>
                    <div className={classes.textField} ><br/>
                        <FormLabel component="legend"><Translate id="common.preparedBy"/> *</FormLabel>
                        <PreparedBySelector
                            className={classes.textField}
                            onUsersQualitySelected = {(prepareBy) => {this.onPrepareBySelected(prepareBy)}}
                        /><br/>
                    </div>

                    <TextField fullWidth
                        id="outlined-multiline-flexible"
                        label={<Translate id="common.comments"/>}
                        multiline
                        className={classes.textField} 
                        rows="4"
                        value={this.state.comments}
                        onChange={(event) => {this.updateProperty(event.target.value)}}
                        margin="normal"
                        variant="outlined"
                    /><br/><br/>
                </Grid>
                
                <Grid container >
                    <DialogActions>
                        <Button 
                            data-cy="btn-save"
                            type="button" 
                            color="primary" 
                            onClick={this.canBeCreateNonconformity}
                            disabled = {!this.canBeSaved() || this.props.isSaving}>
                            {<Translate id="common.save"/>}
                        </Button>
                        <Button onClick={() => {this.props.history.push(`/qualityfailurereport/${qualityFailure.token}`)}} color="secondary">
                            {<Translate id="common.cancel"/>}
                        </Button>
                    </DialogActions>
                </Grid> 

                <Toaster 
                    message = {this.state.toasterMessage}
                    open = {this.state.showToaster}
                    variant = {this.state.toasterVariant}
                    onClose = {() => {this.setState({ showToaster:false})}}
                /> 

            </div>
        )
    }
}

const viewStyles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        paddingLeft: "100px"
    },
    tetxtFieldFull:{
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        paddingRight: "150px"
    },
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 450,
    },
    textAreaField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 440,
        height: 80,
      },
    dense: {
      marginTop: 19,
    },
    menu: {
      width: 200,
    },
    footerForm:{
        display: "flex",
        paddingRight: "60px",
    },
    formControl:{margin: theme.spacing.unit},
    toolbar:{},
    searchInput:{ },
    button:{ },
    actionsToolbar:{ },
    showingUsersCounter:{ },
    grow:{},
    supplierBadge:{}
});

export default withRouter(withStyles(viewStyles, { withTheme:true })(FormView));